import { useEffect } from 'react'

import { Typography } from '@corabank/arco'
import { useDocs } from '@Store'

import constants from '../../constants'
import { INFO_PAGE_LINKS, INFO_PAGE_TEXTS } from './constants'
import * as Styled from './styles'

const { IS_PROD } = constants

const SuccessStep = () => {
  const { businessRegistrationTexts, businessStatus, personRegistrationTexts } =
    useDocs()
  const statusDoc =
    personRegistrationTexts?.length > 0 ? 'PENDING_DOCUMENT' : 'DOCUMENT_SENT'
  const infoType = ['IN_ANALYSIS', 'FINALIZED'].includes(businessStatus)
    ? businessStatus
    : statusDoc

  const handleLoginClick = (): void => {
    const linkUrl = IS_PROD ? INFO_PAGE_LINKS.PRODUCTION : INFO_PAGE_LINKS.STAGE
    window.open(linkUrl, '_blank')
  }

  useEffect(() => {
    INFO_PAGE_TEXTS[infoType].METRIC &&
      mixpanel.track(INFO_PAGE_TEXTS[infoType].METRIC)
  }, [infoType])

  return (
    <Styled.InfoPageContent m="136px auto 0" maxWidth="500px">
      {INFO_PAGE_TEXTS[infoType].ICON}

      <Styled.InfoPageTitle variant="title3" weight="bold" textAlign="center">
        {INFO_PAGE_TEXTS[infoType].TITLE(businessRegistrationTexts?.length)}
      </Styled.InfoPageTitle>

      <Typography variant="body1" color="graysGray1" textAlign="center">
        {INFO_PAGE_TEXTS[infoType].TEXT(businessRegistrationTexts?.length)}
      </Typography>

      {INFO_PAGE_TEXTS[infoType]?.BUTTON_LABEL && (
        <Styled.InfoPageButton size="small" onClick={handleLoginClick}>
          {INFO_PAGE_TEXTS[infoType]?.BUTTON_LABEL}
        </Styled.InfoPageButton>
      )}
    </Styled.InfoPageContent>
  )
}

export { SuccessStep }
